import "./DesktopAdvantages.css";
import { useLang } from "../../../../i18n/LangContext";
import directTraffic from "../../../../assets/desktopAdvertise/advantages/direct-traffic.svg";
import expertise from "../../../../assets/desktopAdvertise/advantages/expertise.svg";
import advanced from "../../../../assets/desktopAdvertise/advantages/advanced.svg";

const icons = [directTraffic, expertise, advanced];

export default function DesktopAdvantages({ id = "advantages" }) {
  const { t } = useLang();
  const data = t?.advertiseAdvantages;
  if (!data) return null;

  return (
    <section id={id} className="adv-root adv-desktop" aria-label="Specific advantages">
      <div className="adv-wrap">
        <header className="adv-head">
          <p className="adv-eyebrow">{data.eyebrow}</p>
          <h2 className="adv-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
        </header>

        <div className="adv-grid">
          {data.cards?.slice(0, 3).map((card, index) => (
            <article key={card.title} className="adv-card">
              <span className="adv-dot adv-dot--top" aria-hidden="true" />

              <div className="adv-icon-wrap" aria-hidden={icons[index] ? "false" : "true"}>
                <div className="adv-icon-ring-main">
                  <div className="adv-icon-ring">
                    {icons[index] ? (
                      <img
                        src={icons[index]}
                        className="adv-icon-img"
                        alt={card.iconAlt || card.title}
                        loading="lazy"
                      />
                    ) : (
                      <div className="adv-icon-ph" />
                    )}
                  </div>
                </div>
              </div>

              <header className="adv-card-head">
                <h3 className="adv-card-title">{card.title}</h3>
                {card.subtitle && <p className="adv-card-kicker">{card.subtitle}</p>}
              </header>

              <p className="adv-card-desc">{card.text}</p>

              <span className="adv-dot adv-dot--bottom" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
